class SwiperEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    var swiper01 = new Swiper('.c-swiper-01', {
      slidesPerView: 1.2,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        // disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 3.1,
          spaceBetween: 16,
        }
      }
    });

    var swiper02 = new Swiper('.c-swiper-02', {
      slidesPerView: 1.2,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        // disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 3.1,
          spaceBetween: 16,
        }
      }
    });
  }
}
